import { Widget, FormProperty } from "../angular2-schema-form-shim";
import { JSONSchema } from "../types/json-schema";
import { WidgetType } from "./registry";

export function isWidgetRequired( widget: Widget<FormProperty> ) {
  let parent = widget.formProperty.parent;
  if ( !parent ) return false;
  let propertyName = widget.formProperty.path.substr( parent.path.length );
  let requiredProperties = <string[]>( <JSONSchema>parent.schema ).required;
  return requiredProperties && requiredProperties.indexOf( propertyName ) > -1;
}

export function getWidgetType( widget: Widget<FormProperty> ): WidgetType {
  return typeof widget.schema.widget === 'string' ? widget.schema.widget : widget.schema.widget.id;
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/overrides.ts